

























































































































import { useFindMasterTop, useFindMasterType } from "@/hooks";
import { Option } from "@/models/class/option.class";
import { StorageStatePreference } from "@/store/models/Preference.model";
import Vue from "vue";
import { mapActions, mapState } from "vuex";

export default Vue.extend({
  name: "PreferenceSales",
  computed: {
    ...mapState({
      state: (st: any) => st.preferenceStore as StorageStatePreference,
    }),
  },
  data() {
    return {
      booleanOptions: [
        {
          label: this.$t("lbl_yes"),
          value: "true",
        },
        {
          label: this.$t("lbl_no"),
          value: "false",
        },
      ],
      topOptions: [] as Option[],
      salesCommisionOptions: [] as Option[],
      loading: {
        salesCommision: false,
        invoiceTerms: false,
      },
    };
  },
  mounted() {
    this.initPreferenceFormSales();
    this.fetchTopList();
    this.fetchSalesCommisionList();
  },
  methods: {
    ...mapActions({
      initPreferenceFormSales: "preferenceStore/initPreferenceFormSales",
      updatePreferenceSales: "preferenceStore/updatePreferenceSales",
    }),
    async fetchTopList() {
      try {
        this.loading.invoiceTerms = true;
        const res = await useFindMasterTop();
        this.topOptions = res.map(item => ({
          key: item.id,
          label: item.value,
          value: item.id,
        }));
      } finally {
        this.loading.invoiceTerms = false;
      }
    },
    async fetchSalesCommisionList() {
      try {
        this.loading.salesCommision = true;
        const res = await useFindMasterType("SALES_COMMISION");
        this.salesCommisionOptions = res.map(item => ({
          key: item.id,
          label: item.value,
          value: item.id,
        }));
      } finally {
        this.loading.salesCommision = false;
      }
    },
    onSave(): void {
      this.updatePreferenceSales();
    },
  },
});
